import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const YOUR_API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const STATUS = process.env.REACT_APP_STATUS;
console.log(STATUS);
const handleInvalidToken = (error) => {
  Swal.fire({
    icon: 'error',
    title: 'Access Denied',
    text: `${error}. Please login again.`,
    allowOutsideClick: true,
    showConfirmButton: true,
    confirmButtonText: 'Login',
  }).then((result) => {
    if (result.isConfirmed || result.dismiss === Swal.DismissReason.backdrop) {
      localStorage.removeItem('token');
      window.location.href = '/#/login';
    }
  });
};
const zodiacApiFunctions = {
  getZodiacUserCounts: async (filter) => {
    console.log(filter);
    try {
      const response = await fetch(
        `${YOUR_API_ENDPOINT}/zodiac/dashboard/getUserData?fromDate=${filter.date.fromDate}&toDate=${filter.date.toDate}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );
      if (!response.ok) {
        if (response.status === 401) {
          handleInvalidToken('Token not provided');
        } else if (response.status === 403) {
          handleInvalidToken('TInvalid token');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'An error occurred while fetching data, please try later.',
          });
        }
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching details:', error);
      throw new Error('Failed to fetch details');
    }
  },

  getVisitCounts: async (filter) => {
    try {
      const url = `${YOUR_API_ENDPOINT}/zodiac/dashboard/getVisitData?fromDate=${filter.date.fromDate}&toDate=${filter.date.toDate}`;
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      if (!response.ok) {
        if (response.status === 401) {
          handleInvalidToken('Token not provided');
        } else if (response.status === 403) {
          handleInvalidToken('Invalid token');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'An error occurred while fetching data, please try later.',
          });
        }
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching GV counts:', error);
      throw new Error('Failed to fetch GV counts');
    }
  },

  getExcelData: async (filter) => {
    console.log(filter);
    try {
      const response = await fetch(
        `${YOUR_API_ENDPOINT}/zodiac/dashboard/getExcelData?fromDate=${filter.date.fromDate}&toDate=${filter.date.toDate}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );
      if (!response.ok) {
        if (response.status === 401) {
          handleInvalidToken('Token not provided');
        } else if (response.status === 403) {
          handleInvalidToken('TInvalid token');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'An error occurred while fetching data, please try later.',
          });
        }
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching details:', error);
      throw new Error('Failed to fetch details');
    }
  },
};

export default zodiacApiFunctions;
